import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Whisper, Tooltip } from "rsuite";

const NavItem = ({
  to,
  label,
  Icon,
  collapsed,
  target = "",
  isDisabled = false,
  children,
  onClick,
}) => {
  const handleClick = (e) => {
    if (isDisabled) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (onClick) onClick(e);
  };

  const linkContent = (
    <NavLink
      to={to}
      target={target}
      end={to === "/"}
      className={({ isActive }) =>
        [
          "sidenav__link",
          isActive ? "is-active" : "",
          collapsed ? "is-collapsed" : "",
          isDisabled ? "is-disabled" : "",
        ]
          .filter(Boolean)
          .join(" ")
      }
      tabIndex={isDisabled ? -1 : undefined}
      aria-disabled={isDisabled ? "true" : undefined}
      onClick={handleClick}
    >
      <span className="sidenav__link__icon" aria-hidden="true">
        {Icon ? <Icon /> : null}
      </span>
      {!collapsed && <span className="sidenav__link__label">{label}</span>}
    </NavLink>
  );

  return collapsed ? (
    <Whisper
      placement="right"
      trigger="hover"
      speaker={<Tooltip className="sidenav-tooltip">{label}</Tooltip>}
    >
      <div className="sidenav__item-inner">
        {linkContent}
        {children}
      </div>
    </Whisper>
  ) : (
    <div className="sidenav__item-inner">
      {linkContent}
      {children}
    </div>
  );
};

NavItem.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  Icon: PropTypes.elementType,
  collapsed: PropTypes.bool,
  target: PropTypes.string,
  isDisabled: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

NavItem.defaultProps = {
  Icon: null,
  collapsed: false,
  target: "",
  isDisabled: false,
  children: null,
  onClick: null,
};

export default NavItem;
